import { render, staticRenderFns } from "./ConfiguracionAcceso.vue?vue&type=template&id=a7ef652e&scoped=true&"
import script from "./ConfiguracionAcceso.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionAcceso.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracionAcceso.vue?vue&type=style&index=0&id=a7ef652e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ef652e",
  null
  
)

export default component.exports